"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFail = exports.WorkflowIDMap = exports.WorkflowStatusMap = exports.ScheduledCallStatus = exports.ConsentStatus = exports.getQuestionTypeInfo = exports.QuestionTypes = exports.SurveyStatus = exports.WorkflowID = exports.WorkflowType = exports.UserStatus = void 0;
/*
* When updating/adding to UserStatus
* Also update/add to WorkflowStatusMap
*/
var UserStatus;
(function (UserStatus) {
    // The CREATING status should never make it to firestore
    // It lets the app know that the user has not created an account yet
    UserStatus["CREATING"] = "creating";
    UserStatus["CREATED"] = "created";
    UserStatus["HOLDING_PRE_SCREEN"] = "holding pre-screen";
    UserStatus["SCREENING"] = "screening";
    UserStatus["SCREENING_ABANDONED"] = "screening abandoned";
    UserStatus["SCREENING_FAIL"] = "screening fail";
    UserStatus["CONSENT"] = "consent";
    UserStatus["CONSENT_FAIL"] = "consent fail";
    UserStatus["CONSENT_ABANDONED"] = "consent abandoned";
    UserStatus["BASELINE"] = "baseline";
    UserStatus["BASELINE_ABANDONED"] = "baseline abandoned";
    UserStatus["PRE_THERAPY"] = "pre-therapy";
    UserStatus["NEVER_STARTED"] = "never started";
    UserStatus["THERAPY"] = "therapy";
    UserStatus["EARLY_TERMINATION_FOLLOWUP"] = "early termination followup";
    UserStatus["EARLY_TERMINATION"] = "early termination";
    UserStatus["DONE"] = "done";
    UserStatus["EXT_ELIGIBLE"] = "ext eligible";
    UserStatus["EXT_DECLINED"] = "ext declined";
    UserStatus["EXT_CONSENT"] = "ext consent";
    UserStatus["EXT_CONSENT_FAIL"] = "ext consent fail";
    UserStatus["EXT_CONSENT_ABANDONED"] = "ext consent abandoned";
    UserStatus["EXT_PRE_THERAPY"] = "ext pre-therapy";
    UserStatus["EXT_NEVER_STARTED"] = "ext never started";
    UserStatus["EXT_THERAPY"] = "ext therapy";
    UserStatus["EXT_DONE"] = "ext done";
    UserStatus["EXT_EARLY_TERMINATION_FOLLOWUP"] = "ext early termination followup";
    UserStatus["EXT_EARLY_TERMINATION"] = "ext early termination";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var WorkflowType;
(function (WorkflowType) {
    WorkflowType["STANDARD"] = "standard";
    WorkflowType["EXTENSION"] = "extension";
})(WorkflowType = exports.WorkflowType || (exports.WorkflowType = {}));
/*
* Property 'workflowID' value on workflow docs for users
* users/{user}/workflows
* When updating/adding to WorkflowID
* Also update/add to WorkflowIDMap
*/
var WorkflowID;
(function (WorkflowID) {
    WorkflowID["DISCLAIMER"] = "disclaimerMeta";
    WorkflowID["ELIGIBILITY"] = "eligibilityMeta";
    WorkflowID["CONSENT"] = "consentMeta";
    WorkflowID["BASELINE"] = "baselineMeta";
    WorkflowID["THERAPY"] = "therapyMeta";
    WorkflowID["EARLY_TERM_CALL"] = "earlyTerminationCallMeta";
    WorkflowID["EARLY_TERM_SURVEYS"] = "earlyTerminationSurveysMeta";
    WorkflowID["EXT_CONSENT"] = "extConsentMeta";
    WorkflowID["EXT_THERAPY"] = "extTherapyMeta";
    WorkflowID["EXT_SCHEDULED_CALLS"] = "extScheduledCallsMeta";
    WorkflowID["EXT_EARLY_TERM_CALL"] = "extEarlyTerminationCallMeta";
    WorkflowID["EXT_EARLY_TERM_SURVEYS"] = "extEarlyTerminationSurveysMeta";
})(WorkflowID = exports.WorkflowID || (exports.WorkflowID = {}));
var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["COMPLETED"] = "completed";
    SurveyStatus["IN_PROGRESS"] = "in-progress";
    SurveyStatus["ASSIGNED"] = "assigned";
    SurveyStatus["EXPIRED"] = "expired";
    SurveyStatus["EXPIRED_IN_PROGRESS"] = "expired-in-progress";
    SurveyStatus["FAILED"] = "failed";
})(SurveyStatus = exports.SurveyStatus || (exports.SurveyStatus = {}));
var QuestionTypes;
(function (QuestionTypes) {
    QuestionTypes["Radio"] = "radio";
    QuestionTypes["Slider"] = "slider";
    QuestionTypes["Buttons"] = "buttons";
    QuestionTypes["TextMultiLine"] = "text-multiline";
    QuestionTypes["Text"] = "text";
    QuestionTypes["CheckBox"] = "checkbox";
    QuestionTypes["DisplayText"] = "displaytext";
})(QuestionTypes = exports.QuestionTypes || (exports.QuestionTypes = {}));
var getQuestionTypeInfo = function (questionType) {
    switch (questionType) {
        case QuestionTypes.Buttons:
            return {
                name: 'Buttons',
                userInfo: 'Select a button',
                creationInfo: 'Allow a user to select a button from available options',
            };
        case QuestionTypes.CheckBox:
            return {
                name: 'Checkbox',
                userInfo: 'Select one or more options',
                creationInfo: 'Allow a user to select one or many available options',
            };
        case QuestionTypes.DisplayText:
            return {
                name: 'Display text',
                userInfo: 'Read the text and click the button to continue',
                creationInfo: 'Display text to a user and have them click the button to continue',
            };
        case QuestionTypes.Radio:
            return {
                name: 'Multiple choice',
                userInfo: 'Select an option',
                creationInfo: 'Allow a user to select one available option',
            };
        case QuestionTypes.Slider:
            return {
                name: 'Slider',
                userInfo: 'Drag the slider to select an option',
                creationInfo: 'Allow a user to select an option on the slider',
            };
        case QuestionTypes.Text:
            return {
                name: 'Text box',
                userInfo: 'Enter your answer in the text box',
                creationInfo: 'Allow a user to enter an answer in the text box',
            };
        case QuestionTypes.TextMultiLine:
            return {
                name: 'Large text box',
                userInfo: 'Enter your answer in the text box',
                creationInfo: 'Allow a user to enter an answer in the large text box',
            };
        default:
            return {
                name: "Unknown question type " + questionType,
                userInfo: "Unknown question type " + questionType,
                creationInfo: "Unknown question type " + questionType,
            };
    }
};
exports.getQuestionTypeInfo = getQuestionTypeInfo;
var ConsentStatus;
(function (ConsentStatus) {
    ConsentStatus["APPROVED"] = "approved";
    ConsentStatus["NOT_APPROVED"] = "not-approved";
    ConsentStatus["ABANDONED"] = "abandoned";
    ConsentStatus["FAILED_APPROVAL"] = "failed-approval";
})(ConsentStatus = exports.ConsentStatus || (exports.ConsentStatus = {}));
var ScheduledCallStatus;
(function (ScheduledCallStatus) {
    ScheduledCallStatus["NOT_SCHEDULED"] = "not-scheduled";
    ScheduledCallStatus["CALL_SCHEDULED"] = "call-scheduled";
    ScheduledCallStatus["DECLINED"] = "declined";
    ScheduledCallStatus["COMPLETED"] = "completed";
    ScheduledCallStatus["ABANDONED"] = "abandoned";
})(ScheduledCallStatus = exports.ScheduledCallStatus || (exports.ScheduledCallStatus = {}));
;
var createMap = function () {
    var createdMap = {};
    // Need to use object.values here because UserStatus is an enum
    // Note: EXT_DECLINED is not considered being part of the extension
    for (var _i = 0, _a = Object.values(UserStatus); _i < _a.length; _i++) {
        var key = _a[_i];
        switch (key) {
            case UserStatus.EXT_ELIGIBLE:
            case UserStatus.EXT_CONSENT:
            case UserStatus.EXT_CONSENT_FAIL:
            case UserStatus.EXT_CONSENT_ABANDONED:
            case UserStatus.EXT_PRE_THERAPY:
            case UserStatus.EXT_THERAPY:
            case UserStatus.EXT_DONE:
            case UserStatus.EXT_EARLY_TERMINATION_FOLLOWUP:
            case UserStatus.EXT_NEVER_STARTED:
            case UserStatus.EXT_EARLY_TERMINATION:
                createdMap[key] = WorkflowType.EXTENSION;
                break;
            default:
                createdMap[key] = WorkflowType.STANDARD;
                break;
        }
    }
    return createdMap;
};
exports.WorkflowStatusMap = createMap();
exports.WorkflowIDMap = (_a = {},
    _a[WorkflowID.ELIGIBILITY] = WorkflowType.STANDARD,
    _a[WorkflowID.CONSENT] = WorkflowType.STANDARD,
    _a[WorkflowID.EXT_CONSENT] = WorkflowType.EXTENSION,
    _a[WorkflowID.BASELINE] = WorkflowType.STANDARD,
    _a[WorkflowID.THERAPY] = WorkflowType.STANDARD,
    _a[WorkflowID.EXT_THERAPY] = WorkflowType.EXTENSION,
    _a[WorkflowID.DISCLAIMER] = WorkflowType.STANDARD,
    _a[WorkflowID.EXT_SCHEDULED_CALLS] = WorkflowType.EXTENSION,
    _a[WorkflowID.EARLY_TERM_CALL] = WorkflowType.STANDARD,
    _a[WorkflowID.EARLY_TERM_SURVEYS] = WorkflowType.STANDARD,
    _a[WorkflowID.EXT_EARLY_TERM_CALL] = WorkflowType.EXTENSION,
    _a[WorkflowID.EXT_EARLY_TERM_SURVEYS] = WorkflowType.EXTENSION,
    _a);
/*
* Reasons that a user would be shown the fail page on surveysaurus
*/
var UserFail;
(function (UserFail) {
    UserFail["DISCLAIM_NOTACCEPTED"] = "disclaimerNotAccepted";
    UserFail["EXISTING_ACCOUNT"] = "existingAccount";
    UserFail["SCREENING_FAIL"] = "screeningFail";
    UserFail["BASELINE_ABANDONED"] = "baselineAbandoned";
    UserFail["SCREENING_ABANDONED"] = "screeningAbandoned";
    UserFail["CONSENT_FAIL"] = "consentFail";
    UserFail["EARLY_TERMINATION"] = "earlyTermination";
})(UserFail = exports.UserFail || (exports.UserFail = {}));
